// export function validatePhone (str) {
//   const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
//   return reg.test(str)
// }
export function validatePhone(phone) {
  // var isMobile = /^[1][3,4,5,7,8][0-9]{9}$/;
  var isPhone = /^((13[0-9])|(14[5,7,9])|(15([0-3]|[5-9]))|(17[0,1,3,5,6,7,8])|(18[0-9])|(19[0-9])|(16[6]))\d{8}$/;
  if (!isPhone.test(phone)) {
    return false;
  }
  return true;
}

/**
 * 验证是否包含汉字
 * @param {*} val
 */
export function CheckChinese(val) {
  var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
  if (reg.test(val)) {
    // return '包含汉字';
    return true;
  } else {
    // return '不包含汉字';
    return false;
  }
}

/**
 * 身份证验证
 * @param {*} sId
 */
export function validateCardNo(sId) {
  var aCity = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };

  var iSum = 0;
  var info = "";
  if (!/^\d{17}(\d|x)$/i.test(sId)) {
    // return '你输入的身份证长度或格式错误';
    return false;
  }
  sId = sId.replace(/x$/i, "a");
  if (aCity[parseInt(sId.substr(0, 2))] == null) {
    // return '你的身份证地区非法';
    return false;
  }
  var sBirthday =
    sId.substr(6, 4) +
    "-" +
    Number(sId.substr(10, 2)) +
    "-" +
    Number(sId.substr(12, 2));
  var d = new Date(sBirthday.replace(/-/g, "/"));
  if (
    sBirthday !=
    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
  ) {
    // return '身份证上的出生日期非法';
    return false;
  }
  for (var i = 17; i >= 0; i--) {
    iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
  }
  if (iSum % 11 != 1) {
    // return '你输入的身份证号非法';
    return false;
  }
  //aCity[parseInt(sId.substr(0,2))]+','+sBirthday+','+(sId.substr(16,1)%2?'男':'女');//此次还可以判断出输入的身份证号的人性别
  return true;
}
/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/**
 * 验证密码是否为6-16字符串的组合
 * @param {*} str
 */
export function validatePass(str) {
  // var reg = /^[a-zA-Z0-9]{6,16}$/;
  var reg = new RegExp("^(?=.*\\d)(?=.*[a-zA-Z]).{6,16}$"); //支持特殊字符
  return reg.test(str);
}

/**
 * 密码是否为6-16的组合
 * @param {*} str
 */
export function validatepPass(str) {
  // var reg = /^[a-zA-Z0-9]{6,16}$/;
  // var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/ //不支持特殊字符
  var reg = new RegExp("^(?=.*\\d)(?=.*[a-zA-Z]).{6,16}$"); //支持特殊字符
  return reg.test(str);
}



// WEBPACK FOOTER //
// ./src/utils/validate.js